module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Filtrar pelo status\n  "), _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "btn btn-default no-bg no-border btn-xs",
    attrs: {
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("\n      Selecione "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.options), function(opt, index) {
    return _c('filtro-status-item', {
      key: index,
      class: _vm.bindClass(opt.class),
      attrs: {
        "val": opt.value,
        "label": opt.label
      },
      on: {
        "focus": _vm.__onFocus,
        "blur": _vm.__onBlur,
        "change": _vm.__onChange
      },
      model: {
        value: (_vm.model),
        callback: function($$v) {
          _vm.model = $$v
        },
        expression: "model"
      }
    })
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22a2f8f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/FiltroStatusLotes.vue
// module id = 1734
// module chunks = 18